var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"card"},[_c('h3',[_vm._v("Расписание")]),(_vm.status == '')?_c('Timetable',{attrs:{"data":_vm.data},on:{"update:data":function($event){_vm.data=$event}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }